import { getRequest, postRequest, ApiEnums } from "./DataRequestService";


async function get_workflows(userId) {
  let apiUrl = ApiEnums.get_workflows;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        user_id: userId,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

//Manage Workflow APIs
// getActPredFcastResults : '/getActPredFcastResults',
// getTopOneModelResults : '/getTopOneModelResults',
// getForecastResults : '/getForecastResults',
// get_sp : '/get_sp',
// getTopThreeModelResults : '/getTopThreeModelResults',

async function getActualPredictedForecastResults(workflow_id) {
  let apiUrl = ApiEnums.getActPredFcastResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getTopOneModelResults(workflow_id) {
  let apiUrl = ApiEnums.getTopOneModelResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getForecastResults(workflow_id) {
  let apiUrl = ApiEnums.getForecastResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

async function getTopThreeModelResults(workflow_id) {
  let apiUrl = ApiEnums.getTopThreeModelResults;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflow_id,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}

//cityName should be capitallize first letter
async function getSalesPersons(cityName) {
  let apiUrl = ApiEnums.get_sp;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        level5: cityName,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}
async function getWorkkflowCombinations(workflowId) {
  // workflowId = 'bd7c3e51-2e06-42ac-80ae-82157c5f467121'
  let apiUrl = ApiEnums.getWorkflowCombinations;
  let requestObject = {
    url: apiUrl,
    config: {
      params: {
        workflow_id: workflowId,
      },
    },
  };
  const responseData = await getRequest(requestObject);
  if (responseData.status === "success") {
    return responseData.data;
  } else if (responseData.status === "failed") {
    console.log(responseData.message);
    return null;
  }
}


export {
  get_workflows,
  getActualPredictedForecastResults,
  getTopOneModelResults,
  getForecastResults,
  getTopThreeModelResults,
  getSalesPersons,
  getWorkkflowCombinations
};